module.exports = __webpack_public_path__ + "media/Z22.e7873dc7.mp3";